import React, { useCallback } from 'react';
import type { Stop } from '../types/api';

interface StopPickerProps {
  onSelect: (stop: Stop) => void;
}

export default function StopPicker({ onSelect }: StopPickerProps) {
  const [query, setQuery] = React.useState('');
  const [results, setResults] = React.useState<Stop[]>([]);
  const [searching, setSearching] = React.useState(false);

  const search = useCallback(async () => {
    if (!query.trim()) return;
    setSearching(true);
    try {
      const coords = query.split(',').map(Number);
      if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
        const res = await fetch(`/api/stops?lat=${coords[0]}&lon=${coords[1]}&radius=500`);
        const data = await res.json();
        setResults(data.stops || []);
      }
    } catch {
      setResults([]);
    } finally {
      setSearching(false);
    }
  }, [query]);

  return (
    <div className="stop-picker">
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search stops (lat, lon)"
        onKeyDown={(e) => e.key === 'Enter' && search()}
      />
      <button onClick={search} disabled={searching}>Search</button>
      {results.length > 0 && (
        <ul className="stop-results">
          {results.slice(0, 10).map((s) => (
            <li key={s.gtfsId} onClick={() => onSelect(s)}>
              {s.name} ({s.code || s.gtfsId}) - {Math.round(s.distance || 0)}m
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
